import React from 'react'

import { Dialog, snackbar } from 'components'
import { useApiCall } from 'hooks'

import { deleteVoucher } from '../api'

interface DeleteVoucherDialogProps {
  handleClose: () => void
  onDone: () => void
  voucherId: number
  voucherTitle: string
}

const DeleteVoucherDialog: React.FC<DeleteVoucherDialogProps> = ({
  handleClose,
  voucherId,
  voucherTitle,
  onDone,
}) => {
  const [deleteVoucherApi, isLoading] = useApiCall<number, void>(deleteVoucher)

  const onDeleteVoucher = async () => {
    try {
      await deleteVoucherApi(voucherId)
      onDone()
    } catch (err) {
      console.error(err)
      snackbar.show('No se pudo eliminar el voucher. Intente de nuevo.')
    }
  }

  return (
    <Dialog
      title={`¿Está seguro que desea eliminar el voucher "${voucherTitle}"?`}
      isOpen
      showActions
      onCancel={handleClose}
      isLoading={isLoading}
      okButtonText="Eliminar"
      okButtonProps={{ disabled: isLoading }}
      onAccept={onDeleteVoucher}
    />
  )
}

export { DeleteVoucherDialog }
